import { Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';

function PatientContent(props) {
    const { data } = props;
    console.log(data);

    return (
        <Grid container spacing={2}>
            <Grid xs={12} sx={{
                backgroundColor: 'rgb(62, 152, 211)'
            }}>
                <Typography variant="h5" className="mb-2 font-primary" sx={{
                    padding: 2,
                    paddingBottom: 0,
                    color: 'white'
                }}>
                    {
                        data.tambon_name !== undefined ?
                            `ต.${data.tambon_name}` :
                            data.amphur_name !== undefined ?
                                `อ.${data.amphur_name}` : `จ.${data.province_name}`
                    }
                </Typography>
                <Typography variant="h6" className="mb-2 font-primary" sx={{
                    fontWeight: 'normal',
                    paddingLeft: 2,
                    paddingRight: 2,
                    color: 'white'
                }}>
                    {
                        data.tambon_name !== undefined ?
                            `อ.${data.amphur_name} จ.${data.province_name}` :
                            data.amphur_name !== undefined ?
                                `จ.${data.province_name}` : ``
                    }
                </Typography>
            </Grid>
            <Grid xs={12} sx={{
                borderBottom: 'solid 1px rgba(0, 0, 0, 0.2)'
            }}>
                <Typography variant="subtitle1" className="font-primary" sx={{
                    color: 'black',
                    textAlign: 'center'
                }}>
                    {
                        `จำนวนผู้ป่วย`
                    }
                </Typography>
                <Typography variant="h6" className="font-primary" sx={{
                    color: 'black',
                    textAlign: 'center',
                    fontWeight: 'normal'
                }}>
                    {data.patient}
                </Typography>
            </Grid>
        </Grid>
    )
}

export default PatientContent
